import { TPatient } from 'src/types/patient'
import {
  TUpdatePatientInCurrentPatientList,
  TRemovePatientFromCurrentPatientList,
  TUpdatePatientMedTeamCommentsInCurrentPatientList,
  TColumnMatchingPatientProps,
} from './patients.types'

export const updatePatientInCurrentPatientList = ({
  updatedPatient,
  currentOrder,
  currentPatientList,
  updatePatientList,
  displayRefreshButton,
}: TUpdatePatientInCurrentPatientList) => {
  if (!currentPatientList) return currentPatientList
  if (currentPatientList.find((patient) => patient.id === updatedPatient.id)) {
    const updatedPatientList = currentPatientList.map((patient) => {
      return patient.id === updatedPatient.id ? { ...updatedPatient } : patient
    })
    updatePatientList(updatedPatientList)
    displayRefreshButton(false)
  } else {
    const currentSortingKey: keyof TPatient =
      (currentOrder.column && COLUMN_MATCHING_PATIENT_PROPS[currentOrder.column]) ?? 'id'
    const isLowerOrGreaterPatients = currentPatientList.reduce((shouldBeInCurrentList, patient) => {
      const isPatientShouldBeInCurrentList = currentOrder.descOrder
        ? patient[currentSortingKey]! > updatedPatient[currentSortingKey]!
        : patient[currentSortingKey]! < updatedPatient[currentSortingKey]!
      return [...shouldBeInCurrentList, isPatientShouldBeInCurrentList]
    }, [] as Array<boolean>)
    if (
      currentPatientList.length < 50 ||
      (isLowerOrGreaterPatients.some((patientLowerOrGreaterThen) => patientLowerOrGreaterThen === true) &&
        isLowerOrGreaterPatients[isLowerOrGreaterPatients.length - 1] === false)
    ) {
      updatePatientList(currentPatientList)
      displayRefreshButton(true)
    } else {
      updatePatientList(currentPatientList)
      displayRefreshButton(false)
    }
  }
}

export const removePatientFromCurrentPatientList = ({
  removedPatient,
  currentPatientList,
  updatePatientList,
}: TRemovePatientFromCurrentPatientList) => {
  const updatedPatientList = currentPatientList.filter((patient) => {
    return patient.id !== removedPatient.id
  })
  updatePatientList(updatedPatientList)
}

export const updatePatientMedTeamCommentsInCurrentPatientList = ({
  patientId,
  medicalTeamCommentListCount,
  currentPatientList,
  updatePatientList,
}: TUpdatePatientMedTeamCommentsInCurrentPatientList) => {
  const updatedPatientList = currentPatientList.map((patient) => {
    return patient.id === patientId
      ? { ...patient, hasMedicalTeamComments: medicalTeamCommentListCount > 0 }
      : patient
  })
  updatePatientList(updatedPatientList)
}

const COLUMN_MATCHING_PATIENT_PROPS: TColumnMatchingPatientProps = {
  PatientId: 'id',
  PatientInfo: 'lastname',
}
